var _circle, _circle2, _circle3, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleWalletLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 112.001,
    cy: 112,
    r: 90.4615,
    fill: "url(#paint0_linear_7250_27550)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 112,
    cy: 112,
    r: 112,
    fill: "url(#paint1_linear_7250_27550)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.001,
    cy: 112,
    r: 67.4872,
    fill: "url(#paint2_linear_7250_27550)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.989 114.255C130.878 115.144 131.356 116.374 131.356 117.672C131.356 118.902 130.878 120.132 129.989 121.02C129.101 121.909 127.871 122.455 126.573 122.455C125.343 122.455 124.113 121.909 123.156 121.02C122.268 120.132 121.789 118.902 121.789 117.672C121.789 116.374 122.336 115.212 123.156 114.255C124.044 113.367 125.274 112.889 126.573 112.889C127.871 112.889 129.101 113.367 129.989 114.255ZM142.768 103.595V133.799C142.768 136.874 140.308 139.334 137.233 139.334H87.7592C84.1376 139.334 81.2676 136.395 81.2676 132.842V108.242V102.502V92.867C81.2676 88.357 84.9576 84.667 89.4676 84.667H127.256C131.014 84.667 133.884 87.742 133.884 91.5003V95.6003H135.114C139.351 95.6003 142.768 99.3586 142.768 103.595ZM86.3243 92.867C86.3243 94.3703 87.5543 95.6003 89.0576 95.6003H128.418V91.3637C128.418 90.6804 127.871 90.1337 127.188 90.1337H89.0576C87.5543 90.1337 86.3243 91.3637 86.3243 92.867ZM137.301 103.595C137.301 102.434 136.344 101.067 135.114 101.067H87.8276C87.2126 101.067 86.7342 101.887 86.7342 102.502V108.242V132.842C86.7342 133.389 87.2126 133.867 87.7592 133.867H137.233C137.301 133.867 137.301 133.799 137.301 133.799V103.595Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7250_27550",
    x1: 112.001,
    y1: 21.5381,
    x2: 112.001,
    y2: 202.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#852EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8458EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7250_27550",
    x1: 112,
    y1: 0,
    x2: 112,
    y2: 224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#852EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8458EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7250_27550",
    x1: 112.001,
    y1: 44.5127,
    x2: 112.001,
    y2: 179.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#852EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8458EF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWalletLight);
export default __webpack_public_path__ + "static/media/CircleWalletLight.02f84d11184dc3376ca295b9d2c6b723.svg";
export { ForwardRef as ReactComponent };